export default __webpack_public_path__ + "static/media/aliza.80e7384c.png";